import { createFileRoute } from '@tanstack/react-router';

import { TargetsPage, performanceState } from '@/features/performance';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/performance/targets')({
  staticData: { crumb: 'nav.targets' },
  component: function Targets() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const now = currentPeriod();
    const { period } = performanceState(search, now);
    return <TargetsPage period={period} onPeriodChange={(p) => void navigate({ search: (prev) => ({ ...prev, period: p === now ? undefined : p }), replace: true })} />;
  },
});
